import GenericRequest, { METHOD_PUT } from '../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../shared/webservices/endpoint';
import RouterUtils from '../../shared/routing/RouterUtils';

export default class DocumentRevisionsRequest extends GenericRequest {

    constructor(document) {
        super(METHOD_PUT, RouterUtils.generateRoute(ApiEndpoints.DOCUMENT_REVISIONS, { id: document.id }));
        this.document = document;
    }

    overrideRequest() {
        let request = {};
        if ( this.document ) request = { ...request, ...this.document };
        return request;
    }
}



// WEBPACK FOOTER //
// ./src/app/documents/ws/CreateDocumentRevisionRequest.js